import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../core/common-service/common.service';
import { RemotePriceChangeService } from '../remote-price-change-service/remote-price-change.service';
import { FilterBarService } from '../../shared/filter-bar-service/filter-bar.service';
import { iVendLookup, Message, RPCMachineDeviceCompatibilityExcelItem, RPCMachineDeviceCompatibilityFilter, RPCMachineDeviceCompatibilityItem, RPCMachineDeviceCompatibilityItemsRequest, RPCMachineDeviceCompatibilityItemsResponse, RPCMachineDeviceConfigurationResponseMetadata } from '../remote-price-change-service/remote-price-change.model';
import { SecurityService } from '../../core/security/security.service';
import { ISubscription } from 'rxjs-compat/Subscription';
import { ExcelService } from '../../core/excel-service/excel.service';
import { Moment } from 'moment';
import * as moment from 'moment';

import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { trigger } from '@angular/animations';

@Component({
  selector: 'app-rpc-status',
  templateUrl: './rpc-compatibility.component.html',
  styleUrls: ['./rpc-compatibility.component.scss']
})
export class RpcCompatibilityComponent implements OnInit {
  Math = Math;
  isRefreshingPage: boolean = false;
  pageSize: number = 1000;
  pageNumber: number = 1;
  majorAccountId: number;
  routeIDList: number[];
  accLocList: number[];
  isProcessing: boolean = false;
  responseMessage: string;
  errorMessage: string;
  tableIsDirty: boolean;
  userID: number;
  params = ['routes', 'accounts', 'buttons', 'rpcCompatibility']; // removed 'rpcStatus'
  filterPosition = 'in';
  view = 'list';
  isMobile = false;
  enableSaveButton: boolean;
  totalNumberOfItems: number;
  pageTopMessage: string;
  private messagesLoaded: boolean = false;
  
  metadata: RPCMachineDeviceConfigurationResponseMetadata;
  rpcStatusItems: RPCMachineDeviceCompatibilityItem[] = new Array();
  ivendLookups: iVendLookup[] = new Array();
  rpcMachineDeviceCompatibilityItemsSubject: ISubscription;
  rpcCompatibilityFilterSubject: ISubscription;
  rpcMachineDeviceCompatibilityRequest: RPCMachineDeviceCompatibilityItemsRequest = new RPCMachineDeviceCompatibilityItemsRequest();
  
  constructor(private _common: CommonService,
    private _rpcService: RemotePriceChangeService,
    private _filterBarService: FilterBarService,
    private _security: SecurityService,
    private _excel: ExcelService,) 
  {
    this._common.setCurrentPage('RPC Device Compatibility');            
  }

  ngOnInit() {
    this.tableIsDirty = false;
    this.enableSaveButton = true;
    this.rpcStatusItems = new Array();
    this.setUpSubjects();
  }

  private setUpSubjects() {
    //this.isRefreshingPage = true;
    this.userID = this._security.getUserID();
    this._filterBarService.selectedMajorAcct.subscribe(data => {
      this.majorAccountId = data;
    });
    this._rpcService.Initialize();
    this._filterBarService.ResetFilterBar();
    // make a stripped-down call to API just to get the lookups
    /*this.rpcMachineDeviceCompatibilityItemsSubject = this._rpcService.GetRPCMachineDeviceCompatibilityItems(this.dummyRequestObjectForLookups()).subscribe(
      (data: RPCMachineDeviceCompatibilityItemsResponse) => {
        console.log("SEARCH REVIEW Result::",data);
        this.ivendLookups = data.iVendLookups;
        this.isRefreshingPage = false;
      },
      (error)=> {
        this.errorMessage = `An error has occurred.  Please try again.  Message=${error.statusText}: ${error.message}`;
        this.isRefreshingPage = false;
      });*/
    // updates to filter bar show up here
    this.rpcCompatibilityFilterSubject = this._filterBarService.rpcCompatibilityFilterUpdate.subscribe((data: RPCMachineDeviceCompatibilityFilter) => {
      const me = this; //stupid debug trick
      this.rpcMachineDeviceCompatibilityRequest.vendorCodes = data.vendorCodes; 
      this.rpcMachineDeviceCompatibilityRequest.machineModels = data.machineModels;
      this.rpcMachineDeviceCompatibilityRequest.deviceNo   = data.deviceNo;
      this.rpcMachineDeviceCompatibilityRequest.rpcCompatibleInd = data.rpcCompatibleInd;
      this.rpcMachineDeviceCompatibilityRequest.dexSinceDateTime = data.dexSinceDateTime;
      this.rpcMachineDeviceCompatibilityRequest.machineActions = data.machineActions;
      if (data.messages && !this.messagesLoaded) {
        this.fillMessages(data.messages);
        this.messagesLoaded = true;
      }
    });

    this._filterBarService.resetFilters.subscribe(() => {
      this.pageNumber = 1;
    });
  }

  private dummyRequestObjectForLookups() {
    var result = new RPCMachineDeviceCompatibilityItemsRequest();
    result.costCenterID = 5141;
    result.pageNumber = 1;
    result.pageSize = 1;
    result.sortColumn = 'locationID';
    result.sortDirection = 'asc';
    return result;
  }

  private onApplyFilters(resetPage: boolean) {   
    if (resetPage) {
      this.pageNumber = 1;
    }
    this.responseMessage = "";
    this.errorMessage = "";
    this.rpcMachineDeviceCompatibilityRequest.costCenterID = Number(this._common.operation.operationNo);
    this.rpcMachineDeviceCompatibilityRequest.pageNumber = this.pageNumber;
    this.rpcMachineDeviceCompatibilityRequest.pageSize = this.pageSize;
    this.rpcMachineDeviceCompatibilityRequest.majorAccountId = this.majorAccountId;
    this.accLocList = this.getAccLocationArray();
    this.routeIDList = this.getRouteArray();
    this.rpcMachineDeviceCompatibilityRequest.accountLocationList = this.accLocList;
    this.rpcMachineDeviceCompatibilityRequest.routeIDList = this.routeIDList;

    this.isRefreshingPage = true;
    console.log(`Search filter: ${JSON.stringify(this.rpcMachineDeviceCompatibilityRequest)}`);
    this.rpcMachineDeviceCompatibilityItemsSubject = this._rpcService.GetRPCMachineDeviceCompatibilityItems(this.rpcMachineDeviceCompatibilityRequest).subscribe(
      (data: RPCMachineDeviceCompatibilityItemsResponse) => {
        console.log("SEARCH REVIEW Result::",data);
        this.metadata = data.metadata;
        this.rpcStatusItems = data.items;
        this.ivendLookups = data.iVendLookups;
        this.totalNumberOfItems = this.metadata.totalItemCount;
        this.isRefreshingPage = false;
        if (data.metadata.totalItemCount === 0) {
          this.responseMessage = `There are no results found`;
        }
      },
      (error)=> {
        this.errorMessage = `An error has occurred.  Please try again.  Message=${error.statusText}: ${error.message}`;
        this.isRefreshingPage = false;
      });
  }

  private getMachineActions(item: RPCMachineDeviceCompatibilityItem): string {
    const actions: string[] = [];
    
    if (item.firmwareActions && item.firmwareActions.toLowerCase() !== 'none') 
      actions.push(`<u><b>Firmware Actions:</b></u><br>${item.firmwareActions}`);
    if (item.passcodeActions && item.passcodeActions.toLowerCase() !== 'none') 
      actions.push(`<u><b>Passcode Actions:</b></u><br>${item.passcodeActions}`);
    if (item.dexMissing && item.dexMissing.toLowerCase() !== 'none') 
      actions.push(`<u><b>DEX Missing:</b></u><br>${item.dexMissing}`);
    if (item.dexDataMissing && item.dexDataMissing.toLowerCase() !== 'none') 
      actions.push(`<u><b>DEX Data Missing:</b></u><br>${item.dexDataMissing}`);
    if (item.multipleDevices && item.multipleDevices.toLowerCase() !== 'none') 
      actions.push(`<u><b>Multiple Devices:</b></u><br>${item.multipleDevices}`);
    if (item.missingPOGSelectionOnDex && item.missingPOGSelectionOnDex.toLowerCase() !== 'none') 
      actions.push(`<u><b>Missing POG Selection on DEX:</b></u><br>${item.missingPOGSelectionOnDex}`);
    
    return actions.join('<br><br>');
  }

  private getMachineActionsExport(item: RPCMachineDeviceCompatibilityItem): string {
    let stringBuilder: string[] = [];

    if (item.firmwareActions && item.firmwareActions.toLowerCase() !== 'none') 
      stringBuilder.push(`Firmware Actions: ${item.firmwareActions}`);
    if (item.passcodeActions && item.passcodeActions.toLowerCase() !== 'none') 
      stringBuilder.push(`Passcode Actions: ${item.passcodeActions}`);
    if (item.dexMissing && item.dexMissing.toLowerCase() !== 'none') 
      stringBuilder.push(`DEX Missing: ${item.dexMissing}`);
    if (item.dexDataMissing && item.dexDataMissing.toLowerCase() !== 'none') 
      stringBuilder.push(`DEX Data Missing: ${item.dexDataMissing}`);
    if (item.multipleDevices && item.multipleDevices.toLowerCase() !== 'none') 
      stringBuilder.push(`Multiple Devices: ${item.multipleDevices}`);
    if (item.missingPOGSelectionOnDex && item.missingPOGSelectionOnDex.toLowerCase() !== 'none') 
      stringBuilder.push(`Missing POG Selection on DEX: ${item.missingPOGSelectionOnDex}`);
    return stringBuilder.join(' ');
  }


  private getStatusDisplay(item: RPCMachineDeviceCompatibilityItem):string {
    let displayValue = "";
    switch (item.rpcCompatibleInd) {
      case true:
        displayValue = "Yes";
        break;
      case false:
        displayValue = "No";
        break;
      default:
        displayValue = "";
    }
    
    return displayValue;
  }

  private getAccountLocationStreetAddress(item: RPCMachineDeviceCompatibilityItem):string {
    return `${item.accountLocation}\r\n${item.locationStreetAddress}, ${item.locationCity}`;
  }

  private getRouteArray() {
    this.routeIDList = new Array();
    if (this._filterBarService.routes.value) {
      for (let i = 0; i < this._filterBarService.routes.value.length; i++) {
        if(this._filterBarService.routes.value[i].selected) {  
          this.routeIDList.push(this._filterBarService.routes.value[i].routeID);
        }
      }
    }  
    return this.routeIDList;
  }

  private getAccLocationArray() { 
    this.accLocList = new Array();
    if (this._filterBarService.accountLocationList.value != null) {
      for (let i = 0; i < this._filterBarService.accountLocationList.value.length; i++) {
        if(this._filterBarService.accountLocationList.value[i].selected) {
          this.accLocList.push(this._filterBarService.accountLocationList.value[i].id);
        }
      }
    }
   return this.accLocList;
  }

  private sortItems(event:any, sortColumn:string) {
    this.rpcMachineDeviceCompatibilityRequest.sortColumn = sortColumn;
    this.rpcMachineDeviceCompatibilityRequest.sortDirection = event ? "ASC":"DESC";
    this.onApplyFilters(false);
  }

  private fillMessages(messages: Message[]) {
    let messagesText = "";
    const globalMessage = messages.find(x => x.costCenterID === null);
    const costCenterMessage = messages.find(x => x.costCenterID === Number(this._common.operation.operationNo));

    if (globalMessage != null && globalMessage.messageText !== null) {
      messagesText = globalMessage.messageText;
    }

    if (costCenterMessage != null && costCenterMessage.messageText) {
      messagesText += ((messagesText !== "" ? "<br>" : "") + costCenterMessage.messageText);
    }

    this.pageTopMessage = messagesText;
  }

  private getExcelTransformedItems(data: RPCMachineDeviceCompatibilityItemsResponse):RPCMachineDeviceCompatibilityExcelItem[] {
    let excelItems: RPCMachineDeviceCompatibilityExcelItem[] = new Array();

    for (let index = 0; index <  data.items.length; index++) {
      const item = data.items[index];
      const excelItem:RPCMachineDeviceCompatibilityExcelItem = new RPCMachineDeviceCompatibilityExcelItem();
      excelItem.CostCenterID                   = item.costCenterID;
      excelItem.AccountLocation                = item.accountLocation;
      excelItem.LocationStreetAddress          = item.locationStreetAddress;
      excelItem.LocationCity                   = item.locationCity;
      excelItem.LocationState                  = item.locationState;
      excelItem.LocationPostalCode             = item.locationPostalCode;
      excelItem.RouteNumber                    = item.routeNumber;
      excelItem.MachineNumber                  = item.machineNumber;
      excelItem.VendorCode                     = item.vendorCode;
      excelItem.DeviceNo                       = item.deviceNo;
      excelItem.LatestDEX            = item.latestVIDexDateTime;
      excelItem.MachineSerialNumber            = item.machineSerialNumber;
      excelItem.MachineModelNumber             = item.machineModelNumber;
      excelItem.MachineBuildStandard           = item.machineBuildStandard;
      excelItem.UserDefinedField               = item.userDefinedField;
      excelItem.ControlBoardModelNumber        = item.controlBoardModelNumber;
      excelItem.ControlBoardSoftwareRevision   = item.controlBoardSoftwareRevision;
      excelItem.CashlessModelNumber           = item.cashless1ModelNumber;
      excelItem.CashlessSoftwareRevision      = item.cashless1SoftwareRevision;
      excelItem.Status                         = this.getStatusDisplay(item);
      excelItem.MachineActions                 = this.getMachineActionsExport(item);

      excelItems.push(excelItem);
    }

    return excelItems;
  }

  private exportToExcel() {
    this.responseMessage = "";
    this.errorMessage = "";
    this.isProcessing = true;
    const allItemsFilteredRequest = {...this.rpcMachineDeviceCompatibilityRequest};
    allItemsFilteredRequest.pageSize = 100000;
    allItemsFilteredRequest.pageNumber = 1;
    console.log(`Export to Excel filter: ${JSON.stringify(allItemsFilteredRequest)}`);
    
    this.rpcMachineDeviceCompatibilityItemsSubject = this._rpcService.GetRPCMachineDeviceCompatibilityItems(allItemsFilteredRequest).subscribe(
      (data: RPCMachineDeviceCompatibilityItemsResponse) => {
        console.log("Excel Export Result::",data);
        let excelItems = this.getExcelTransformedItems(data);

        const dateFormat = "YYYYMMDD";
        let _now: Moment = moment(new Date());
        const fileName = 'RPC Compatibility' + '_' + _now.format(dateFormat);
          this._excel.exportAsExcelFile(excelItems, fileName);
        this.isProcessing = false;
      }),
      (error => {
        console.log("Excel Export fail");
        this.errorMessage = `An error has occurred.  Please try again.  Message=${error.statusText}: ${error.message}`;
        this.isProcessing = false;
      });
  } // end exportToExcel

  pageChanged() {
    window.scrollTo(0, 0);
    this.onApplyFilters(false);
  }

  onChangeView(view) {
    this.view = view;
    if (this.isMobile) {
      this.filterPosition = 'out';
    } else {
      this.filterPosition = view === 'grid' ? 'out' : 'in';
    }
  }
}
